module.exports = __webpack_public_path__ + "2ca1a6a3a867477768edff622f4917cb.MP3";